<div mat-dialog-title class="dialog-title p-3 pr-5 clearfix">
  <h5>
    Select Vendor{{ data['multiple'] ? 's' : '' }}
    <span>
      ({{ dataSource.selection.selected.length }})
    </span>
  </h5>

  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    (click)="onClose()"
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>

  <form class="form-inline my-2 my-lg-0 float-lg-right" (ngSubmit)="dataSource.getData(true)">
    <input
      class="form-control mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search"/>

    <button
      mat-raised-button
      color="secondary"
      class="mr-2 mr-lg-3 my-1"
      type="submit"
      matTooltip="Run the current search">
      <mat-icon>search</mat-icon> Search
    </button>

    <button
      mat-raised-button
      type="button"
      class="mr-2 my-1"
      (click)="onClearSelected()">
      Clear Selected
    </button>
  </form>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    matSortActive="id"
    matSortDirection="asc"
    matSortDisableClear >
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="65">
        <mat-checkbox
          (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          appMarginRight>
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef matTooltip="Toggle sorting by the id of the vendor.">
        #
      </th>
      <td mat-cell *matCellDef="let vendor">
        {{ vendor.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the name of the vendor.">
        Name
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor.name  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="is_prequalified">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Prequalified
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor.is_prequalified ? 'Yes' : 'No'  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="contact_details">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Contact
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding">
        <div *ngIf="vendor?.email">
          <a [href]="'mailto:' + vendor.email" target="_blank">{{ vendor.email }}</a>
        </div>

        <div *ngIf="vendor?.phone">
          <a [href]="'tel:' + vendor.phone_e164" target="_blank">{{ vendor.phone }}</a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="linked_assets_count">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Linked Assets Count
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding text-wrap">
        {{ vendor?.linked_assets_count ?? 0 }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header matTooltip="Toggle sorting by the created at date of the vendor.">
        Created At
      </th>
      <td mat-cell *matCellDef="let vendor" class="no-padding">
        {{ (vendor.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="dataSource.selection.toggle(row.id)"></tr>
  </table>
</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-3 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <button
    class="my-2 mx-1"
    mat-raised-button
    color="primary"
    type="button"
    (click)="onSaveAndClose()"
    [disabled]="data['required'] && !dataSource.selection.hasValue()">
    Select & Close
  </button>
</mat-dialog-actions>




